var map = {
	"./annotation.svg": "53a4",
	"./assets.svg": "8dbc",
	"./camera.svg": "2e09",
	"./checkbox.svg": "cb07",
	"./date-time.svg": "d501",
	"./document-number.svg": "2789",
	"./facility.svg": "dbb7",
	"./instructions.svg": "2c33",
	"./location.svg": "c535a",
	"./media.svg": "ce01",
	"./number.svg": "5c5f",
	"./select.svg": "ecdf",
	"./signature.svg": "9f53",
	"./site.svg": "1d73",
	"./slider.svg": "d80d",
	"./text-answer.svg": "dc7c",
	"./time.svg": "b582"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e17f";